import { Observable } from 'rxjs';
import { CommandTypes } from './command-types';
import { UICommandSettingsManager } from './ui-command-settings-manager';
import { UICommand } from './ui-command';
import { UIResultCommand } from './ui-result-command';
import type { UICommandInterface, UIResultCommandInterface } from '@nts/std/interfaces';

export class CommandFactory {

    static createUICommandWithType(
        type: CommandTypes,
        execute: (x: any) => Promise<void>,
        canExecuteMethod: () => Observable<boolean> = null,
        isHighlightMethod: (x: any) => Observable<boolean> = null,
        isVisibleMethod: () => Observable<boolean> = null
    ): UICommandInterface {

        const manager = new UICommandSettingsManager();
        const cmd = manager.setUICommand(type, CommandFactory.createUICommand(execute, canExecuteMethod, isHighlightMethod, isVisibleMethod));
        return cmd;
    }

    static createUICommand(
        execute: (x: any, y?: any) => Promise<void> | void,
        canExecuteMethod: () => Observable<boolean> = null,
        isHighlightMethod: (x: any) => Observable<boolean> = null,
        isVisibleMethod: () => Observable<boolean> = null
    ): UICommandInterface {
        const command = canExecuteMethod != null ?
            new UICommand(() => canExecuteMethod(), execute, isHighlightMethod, isVisibleMethod) :
            new UICommand(null, execute, isHighlightMethod, isVisibleMethod);
        return command;
    }

    static createResultUICommand<TResult>(
        execute: (x: any) => Promise<TResult> | TResult,
        canExecuteMethod: () => Observable<boolean> = null,
        isHighlightMethod: (x: any) => Observable<boolean> = null,
        isVisibleMethod: () => Observable<boolean> = null
    ): UIResultCommandInterface<TResult> {
        const command = canExecuteMethod != null ?
            new UIResultCommand<TResult>(() => canExecuteMethod(), execute, isHighlightMethod, isVisibleMethod) :
            new UIResultCommand<TResult>(null, execute, isHighlightMethod, isVisibleMethod);
        return command;
    }
}

